import { render } from "./GoBackButton.vue?vue&type=template&id=58c0240f&ts=true"
import script from "./GoBackButton.vue?vue&type=script&lang=ts"
export * from "./GoBackButton.vue?vue&type=script&lang=ts"

import "./GoBackButton.vue?vue&type=style&index=0&id=58c0240f&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__